<template>
  <div class="rm-screen">
    <div v-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!hasRows" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-chart-bar</v-icon>
      {{ $t("no_data") }}
    </div>

    <template v-else>
      <div class="rm-stats">
        <div v-for="(stat, index) in kpis" :key="stat.key" class="rm-stat" :class="{ 'rm-stat--inverse': index === 0 }">
          <span class="rm-stat__label">{{ stat.label }}{{ stat.key === "meals" ? "" : currencySuffix }}</span>
          <span class="rm-stat__value rm-num">{{ stat.value }}</span>
        </div>
      </div>

      <ul class="rm-list rm-card">
        <li v-for="row in rows" :key="row.key" class="gm-user">
          <div class="gm-user__btn">
            <span class="gm-user__text">
              <span class="gm-user__name">{{ row.name }}</span>
              <span class="gm-user__meta rm-num">{{ $t("meal_count") }} {{ row.meals }}</span>
              <span class="gm-user__meta rm-num">
                {{ $t("company_amount") }} {{ money(row.company) }} · {{ $t("employee_amount") }} {{ money(row.employee) }}
              </span>
            </span>
            <span class="cmm-money rm-num">{{ money(row.amount) }}</span>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import CompanyDesktopMultiRestaurantSummary from "@/components/company-report/desktop/screens/multi/CompanyDesktopMultiRestaurantSummary.vue";
import "@/components/report/mobile/screens/group/groupMobileUsers.scss";
import hasMultiMobile from "../../hasMultiMobile";

/**
 * Mobilni "Pregled po restoranima" firme "više restorana": po restoranu broj obroka i iznos (desno), a ispod koliko
 * je platila firma, a koliko radnik. Restorani i period su u zaglavlju. Računa kao ekran za računar.
 */
export default {
  name: "CompanyMobileMultiRestaurantSummary",
  extends: CompanyDesktopMultiRestaurantSummary,
  mixins: [hasMultiMobile],
};
</script>
